import React, { useState } from 'react';
import { RiNotification4Fill } from "react-icons/ri";
import { FaSpinner, FaTimes } from 'react-icons/fa';
import styles from './NotificationsAlert.module.css';
import { useAlert } from '../../context/AlertContext';
import CocUploadModal from './CocUploadModal';

const NotificationsAlert = () => {
  const { processingJobs, completedJobs, clearCompletedJob, clearCompletedJobs } = useAlert();
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedResult, setSelectedResult] = useState(null);
  const [showResultModal, setShowResultModal] = useState(false);

  const totalNotifications = processingJobs.length + completedJobs.length;

  const handleClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleClearCompleted = () => {
    clearCompletedJobs();
  };

  const handleViewResult = (job) => {
    setSelectedResult(job.result);
    setShowResultModal(true);
    setShowDropdown(false);
  };

  const handleRemoveCompletedJob = (jobId, e) => {
    e.stopPropagation();
    clearCompletedJob(jobId);
  };

  return (
    <div className={styles.notificationsAlert}>
        <button 
          className={styles.notificationButton} 
          aria-label={`Notifications (${totalNotifications} items)`} 
          onClick={handleClick}
        >
            <RiNotification4Fill />
            {totalNotifications > 0 && (
              <span className={styles.notificationBadge}>
                {totalNotifications > 99 ? '99+' : totalNotifications}
              </span>
            )}
        </button>

        {showDropdown && totalNotifications > 0 && (
          <div className={styles.notificationDropdown}>
            <div className={styles.dropdownHeader}>
              <h4>Processing Jobs</h4>
              {completedJobs.length > 0 && (
                <button 
                  className={styles.clearButton}
                  onClick={handleClearCompleted}
                >
                  Clear All
                </button>
              )}
            </div>
            
            <div className={styles.dropdownContent}>
              {/* Processing Jobs */}
              {processingJobs.map(job => (
                <div key={job.jobId} className={styles.notificationItem}>
                  <FaSpinner className={styles.spinningIcon} />
                  <div className={styles.notificationText}>
                    <div className={styles.notificationTitle}>{job.fileName}</div>
                    <div className={styles.notificationSubtitle}>
                      Status: {job.status}
                    </div>
                  </div>
                </div>
              ))}

              {/* Completed Jobs */}
              {completedJobs.map(job => (
                <div 
                  key={job.jobId} 
                  className={`${styles.notificationItem} ${styles.clickable}`}
                  onClick={() => handleViewResult(job)}
                >
                  <div className={styles.completedBadge}>✓</div>
                  <div className={styles.notificationText}>
                    <div className={styles.notificationTitle}>
                      {job.fileName || 'COC Document'}
                    </div>
                    <div className={styles.notificationSubtitle}>
                      Click to view results
                    </div>
                  </div>
                  <button
                    className={styles.removeButton}
                    onClick={(e) => handleRemoveCompletedJob(job.jobId, e)}
                    aria-label="Remove notification"
                  >
                    <FaTimes />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Result Modal */}
        <CocUploadModal 
          isOpen={showResultModal} 
          onClose={() => {
            setShowResultModal(false);
            setSelectedResult(null);
          }}
          preloadedResult={selectedResult}
        />
    </div>
  );
}

export default NotificationsAlert;

